import React, { useState } from "react";
import { message } from "antd";
import Joi from "joi-browser";
import Form from "../../components/Form";
import { addGSheet } from "../Knowledge_base/service";
import { showErrorToast } from "V2.0/utils";

function AddSpreadsheet({ projects, activeProject, onClose, refetch, KB }) {
  const [inputField] = useState({
    url: "",
  });

  const [loading, setLoading] = useState(false);

  const [errorMessage] = useState({});

  const template = [
    {
      name: "url",
      label: "Google Sheet URL",
      description: `Please make sure the Google sheet is public`,
      type: "text",
      placeholder: "Paste here",
    },
  ];

  const buttonInfo = { label: "Add Sheet", style: "entire-width" };
  // const buttonInfo1 = { label: " Create A", style: "" };

  const schema = {
    url: Joi.string().uri().min(2).max(500).required().label("URL"),
  };

  const handleSubmit = async (data) => {
    {
      try {
        const response = await addGSheet(
          KB._id,
          projects[activeProject]._id,
          data
        );
        if (response.status === 200) {
          message.success("Success. Your file is now been queued.");
          refetch(projects[activeProject]._id);
          onClose();
          setLoading(false);
        }
      } catch (e) {
        showErrorToast(e, "Failed to add spreasheet");
        setLoading(false);
      }
    }
  };

  return (
    <Form
      errorMessage={errorMessage}
      inputField={inputField}
      template={template}
      schema={schema}
      buttonInfo={buttonInfo}
      onSubmit={handleSubmit}
      loading={loading}
      setLoading={setLoading}
    />
  );
}

export default AddSpreadsheet;
